import type { ButtonHTMLAttributes } from 'react';
import { Link, type LinkProps } from 'react-router';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'danger' | 'quiet';

interface StyleProps {
  variant?: Variant;
  size?: 'medium' | 'small';
  block?: boolean;
}

export function buttonClass(
  { variant = 'secondary', size = 'medium', block = false }: StyleProps = {},
  extra?: string,
) {
  return [styles.button, styles[variant], size === 'small' && styles.small, block && styles.block, extra]
    .filter(Boolean)
    .join(' ');
}

export function Button({
  variant,
  size,
  block,
  className,
  type = 'button',
  ...rest
}: StyleProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type={type} className={buttonClass({ variant, size, block }, className)} {...rest} />;
}

export function ButtonLink({ variant, size, block, className, ...rest }: StyleProps & LinkProps) {
  return <Link className={buttonClass({ variant, size, block }, className)} {...rest} />;
}
